import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Es para mí si nunca he leído un libro de relaciones?',
    answer: 'Sí. Esta guía está diseñada para mujeres que quieren reconectar con su pareja sin necesidad de experiencia previa en terapia o libros de autoayuda. Es práctica, directa y fácil de seguir.'
  }, {
    question: '¿Es un producto digital?',
    answer: 'Sí. Recibirás un PDF descargable que puedes leer en tu celular, tablet o computadora. No se envía nada físico.'
  }, {
    question: '¿Cuándo lo recibo después de comprarlo?',
    answer: 'Al instante. Después de completar tu pago en Hotmart, recibirás un correo con el enlace de descarga inmediata.'
  }, {
    question: '¿Puedo leerlo en cualquier dispositivo?',
    answer: 'Sí. El formato PDF es compatible con celulares, tablets, laptops y computadoras de escritorio.'
  }, {
    question: '¿Funciona si tengo poco tiempo disponible?',
    answer: 'Absolutamente. Cada capítulo está diseñado para leerse en pocos minutos. Puedes avanzar a tu ritmo, incluso dedicando solo 10 minutos al día.'
  }, {
    question: '¿Qué pasa si no me funciona?',
    answer: 'Tienes una garantía de satisfacción de 7 días. Si no estás conforme, puedes solicitar un reembolso completo sin preguntas.'
  }, {
    question: '¿Necesito comprar algo más para que funcione?',
    answer: 'No. El ebook incluye todo lo que necesitas: el método completo + los 3 bonos gratuitos. No hay costos ocultos ni ventas adicionales.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-16 bg-[#faf8f6]" data-id="element-31">
      <div className="max-w-3xl mx-auto px-6" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-bold tracking-wider text-[#9d4b6b] uppercase bg-[#9d4b6b]/10 rounded-full" data-id="element-34">
            Preguntas frecuentes
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-[#2d2d2d] mb-4" data-id="element-35">
            ¿Tienes dudas? Te las resolvemos
          </h2>
          <p className="text-[#5a5a5a] text-lg" data-id="element-36">
            Aquí encontrarás respuestas a las preguntas más comunes
          </p>
        </div>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl border border-gray-100 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-38">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-39">
                <span className="font-medium text-[#2d2d2d] text-lg pr-4" data-id="element-40">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#9d4b6b] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-41" />
              </button>

              <AnimatePresence data-id="element-42">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-43">
                    <div className="px-5 pb-5 text-[#5a5a5a] leading-relaxed border-t border-gray-50 pt-3" data-id="element-44">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}